<p-confirmDialog />

<app-card-content [border]="false" [headerColor]="true" icon="pi pi-sitemap" title="Corpo Societário" subtitle="Sócios atuais e antigos do prestador">
    <div card-header><app-botao-acoes label="Ações" [iconPos]="EInconPos.LEFT" [items]="itensAcoes" [iconColumns]="2" [permissaoUf]="pessoa()?.uf ?? null" /></div>

    <app-tab-container [options]="options" [(selected)]="selected" [useHeader]="false" (onChanged)="onComposicaoAlterada($event)">
        <app-tab-content value="ATUAL"><ng-container [ngTemplateOutlet]="tabelaSocios"></ng-container></app-tab-content>
        <app-tab-content value="ANTIGA"><ng-container [ngTemplateOutlet]="tabelaSocios"></ng-container></app-tab-content>
    </app-tab-container>
</app-card-content>

<ng-template #tabelaSocios>
    <app-custom-table
        [metadata]="tableMetadata"
        [data]="sociosTabela()"
        [columnOrder]="columnOrder"
        [loading]="carregando()"
        [first]="first()"
        [rows]="rows()"
        [totalRecords]="totalRecords()"
        [rowsPerPageOptions]="[10, 15, 20]"
        [showActions]="true"
        [showExpandButton]="true"
        [resumoColumnLabel]="'Contato'"
        [initialViewMode]="'table'"
        [cardColumns]="2"
        [permissaoUf]="pessoa()?.uf ?? null"
        (onPageChange)="onPaginaAlterada($event)"
        (sortData)="onOrdenacaoAlterada($event)"
    />

    <div class="table-footer">
        <div class="legend-group">
            <div class="legend"><span class="legend-color debt"></span>Médicos Devedores</div>
            <div class="legend"><span class="legend-color deceased"></span>Médicos Falecidos</div>
        </div>
        <span>Total: {{ totalRecords() }}</span>
    </div>
</ng-template>

<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Sócio do quadro societário."
    [visible]="dialogVisivel()"
    (visibleChange)="dialogVisivel.set($event)"
    [style]="{ width: 'min(94vw, 720px)' }"
    [appendTo]="'body'"
    [header]="socioEmEdicao() ? 'Editar sócio' : 'Novo sócio'"
>
    <form [formGroup]="formSocio" class="socio-form">
        <div class="socio-form__full">
            <label>Sócio *</label>
            <div class="socio-form__search">
                <input pInputText formControlName="nome" readonly />
                <p-button label="Localizar" icon="pi pi-search" severity="secondary" (onClick)="abrirPesquisaSocio()" />
                <p-button label="Selecionar do corpo clínico" icon="pi pi-users" severity="secondary" [outlined]="true" (onClick)="corpoClinicoVisivel.set(true)" />
            </div>
        </div>

        <div>
            <label>ID</label>
            <input pInputText formControlName="idSocio" readonly />
        </div>

        <div>
            <label>UF</label>
            <input pInputText formControlName="ufSocio" readonly />
        </div>

        <div class="socio-form__full">
            <label>Cargo *</label>
            <p-select formControlName="idCargo" [options]="cargos()" optionLabel="cargo" optionValue="idCargo" appendTo="body" />
        </div>

        <div>
            <label>Data Entrada *</label>
            <input pInputText type="date" formControlName="dataEntrada" />
        </div>

        <div>
            <label>Data Saída</label>
            <input pInputText type="date" formControlName="dataSaida" />
            @if (datasInvalidas()) {
                <small class="field-error">Data de saída não pode ser menor que a entrada.</small>
            }
        </div>
    </form>

    <ng-template #footer>
        <p-button label="Cancelar" severity="secondary" (onClick)="dialogVisivel.set(false)" />
        <p-button label="Salvar" icon="pi pi-check" [loading]="salvando()" [disabled]="formSocio.invalid || datasInvalidas()" (onClick)="salvarSocio()" />
    </ng-template>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="A data será aplicada a todos os sócios marcados."
    [visible]="saidaEmLoteVisivel()"
    (visibleChange)="saidaEmLoteVisivel.set($event)"
    [style]="{ width: 'min(94vw, 460px)' }"
    [appendTo]="'body'"
    header="Informar data de saída em lote"
>
    <form [formGroup]="formSaidaEmLote" class="saida-lote-form">
        <p class="hint">Sócios selecionados: {{ selecionadosCount() }}</p>

        <div>
            <label>Data Saída *</label>
            <input pInputText type="date" formControlName="dataSaida" />
            @if (saidaEmLoteDataInvalida()) {
                <small class="field-error">Data de saída não pode ser menor que a entrada dos sócios selecionados.</small>
            }
        </div>
    </form>

    <ng-template #footer>
        <p-button label="Cancelar" severity="secondary" (onClick)="saidaEmLoteVisivel.set(false)" />
        <p-button label="Confirmar" icon="pi pi-check" [loading]="salvandoSaidaEmLote()" [disabled]="formSaidaEmLote.invalid || saidaEmLoteDataInvalida()" (onClick)="confirmarSaidaEmLote()" />
    </ng-template>
</p-dialog>

<app-pesquisar-pessoa-custom [(showDialog)]="pesquisaSocioVisivel" [tiposPessoaPermitidos]="['MEDICO', 'PRESTADOR', 'OUTROSPF', 'OUTROSPJ']" (pessoa)="selecionarSocio($event)" />

<app-seletor-medico-corpo-clinico [(showDialog)]="corpoClinicoVisivel" [idPrestador]="pessoa()?.id ?? 0" [ufPrestador]="pessoa()?.uf ?? ''" titulo="Selecionar médico do corpo clínico" (medico)="selecionarSocio($event)" />
